'use strict';
import angular from 'angular';
import './scripts/steps.ctrls';
import './scripts/steps.directives';
import './scripts/steps.services';

import stepsHtmlUrl from './views/steps.html';
import stepGroupsHtmlUrl from './views/stepGroups.html';

angular.module('steps', ['steps.ctrls', 'steps.directives', 'steps.services'])

    .config(['$stateProvider', function($stateProvider){

        $stateProvider
            .state('steps', {
                parent: 'layout',
                url: '/admin/steps',
                templateUrl: stepsHtmlUrl,
                controller: 'StepsController'

            })
            .state('stepGroups', {
                parent: 'layout',
                url: '/admin/stepGroups',
                templateUrl: stepGroupsHtmlUrl,
                controller: 'StepGroupsController'
            })

    }]);